var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home",class:[_vm.colorTheme]},[_c('v-app',{attrs:{"id":"inspire"}},[_c('NavDrawer'),_c('AppBar'),_c('RestaurantOrderHistory'),_c('Footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }